// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type FolderIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from folder.svg
 */
export default function FolderIcon(props: FolderIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="FolderIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M4.5 1a1.5 1.5 0 0 1 1.339.823l.056.125.018.052H14.5a1.5 1.5 0 0 1 1.473 1.215l.02.14L16 3.5v10a1.5 1.5 0 0 1-1.355 1.493L14.5 15h-13a1.5 1.5 0 0 1-1.493-1.355L0 13.5v-11a1.5 1.5 0 0 1 1.356-1.493L1.5 1zM15 5H1v8.5a.5.5 0 0 0 .41.492L1.5 14h13a.5.5 0 0 0 .492-.41L15 13.5zM1.5 2h3l.09.008a.5.5 0 0 1 .402.402l.016.18A.5.5 0 0 0 5.5 3h9l.09.008A.5.5 0 0 1 15 3.5V4H1V2.5l.008-.09A.5.5 0 0 1 1.5 2"
        />
      </g>
    </svg>
  );
}
